<template>
    <div>
        <div class="ibox form">
            <div class="ibox-title ibox-grey">
                <h4>{{ __(sectionTitle) }}</h4>
                <slot name="help"></slot>
            </div>

            <attendant-department-form
                ref="attendant_department_form"
                :saDepartments="saDepartments"
                :disabled="preview || mode == 'application-settings'"
                :boxTitle="providerTitle"
                :mode="mode"
                @change="departmentChange"
            />

            <client-data-form
                ref="client_form"
                v-model="clientForm"
                :boxTitle="__('client_data')"
                :viesButton="true"
                :index="0"
                :disabled="preview"
                :permission_access="permission_access"
                :mode="mode"
                :shortName="true"
                :copyButtonChecked="isDataCopied"
                @changeCountry="clientCountryChange"
                @chamgeIdType="clientIdTypeChange"
            />
            <template v-if="isDataCopied == true && mode != 'application-settings'">
                <client-data-form
                    class="client-form"
                    key="client_form_1"
                    :boxTitle="__('user_data_form') + ' 1'"
                    :permission_access="permission_access"
                    :copyClientDataButton="true"
                    :isEnabledCopyButton="isEnabledCopyButton && !preview"
                    :copyButtonChecked="isDataCopied"
                    :value="clientForm"
                    :disabled="isDataCopied || preview"
                    :index="1"
                    :mode="mode"
                    @copy="copyClientData"
                />
            </template>
            <template v-else-if="isDataCopied == false">
                <client-data-form
                    class="client-form"
                    key="client_form_2"
                    :permission_access="permission_access"
                    :boxTitle="__('user_data_form') + ' 1'"
                    :copyClientDataButton="true"
                    :isEnabledCopyButton="isEnabledCopyButton"
                    :copyButtonChecked="isDataCopied"
                    :index="1"
                    :disabled="preview"
                    :mode="mode"
                    :logo="true"
                    @copy="copyClientData"
                    v-model="clientFormFirst"
                />
            </template>

            <component
                class="client-form"
                v-for="(form, index) in clientsForms"
                :key="form.id"
                :is="form.element"
                :id="form.id"
                :index="index + 2"
                :boxTitle="__('user_data_form') + ' ' + (index + 2)"
                :deleteButton="true"
                :countryProp="defaultCountry"
                :idNumberTypeProp="defaultIdNumberType"
                :disabled="preview"
                :mode="mode"
                :logo="true"
                @delete="deleteClientForm"
            />

            <div class="ibox-content" v-if="!preview">
                <div class="row">
                    <div
                        class="col-sm-4 col-sm-offset-2 m-b"
                        v-if="!isDataCopied && mode != 'application-settings'"
                    >
                        <a
                            href="#"
                            class="btn btn-primary btn-sm"
                            @click.prevent="addClientForm"
                            ><i class="fa fa-plus"></i>
                            {{ __("add_another_tenant") }}</a
                        >
                    </div>
                    <div class="col-12">
                        <slot name="ksef-info"></slot>
                    </div>
                    <div class="col-12">
                        <slot name="buttons"></slot>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import AttendantDepartmentForm from "../../components/forms/CreateClient/AttendantDepartmentForm";
import ClientDataForm from "../../components/forms/CreateClient/ClientDataForm";
import { mapActions } from "vuex";

export default {
    components: {
        AttendantDepartmentForm,
        ClientDataForm
    },
    data() {
        return {
            clientsForms: [],
            rowsCount: 2,
            defaultCountry: null,
            defaultIdNumberType: null,
            isDataCopied: false,
            clientForm: {
                name: "",
                countrySelected: null,
                idNumberType: null,
                idNumber: "",
                idNumberSecondaryType: "",
                idNumberSecondary: "",
                address1: "",
                address2: "",
                zip: "",
                city: "",
                remarks: "",
                departmentCountryChecked: false,
                departmentCountrySelected: null,
                short_name: '',
                idVies: false,
                idSecondaryVies: false
            },
            clientFormFirst: {
                name: "",
                countrySelected: null,
                idNumberType: null,
                idNumber: "",
                idNumberSecondaryType: "",
                idNumberSecondary: "",
                address1: "",
                address2: "",
                zip: "",
                city: "",
                remarks: "",
                departmentCountryChecked: false,
                departmentCountrySelected: null
            }
        };
    },
    props: {
        saDepartments: {
            type: Array,
            default: () => []
        },
        currentSaDepartment: {
            default: null
        },
        countryTranslations: {
            type: Object,
            default: () => ({})
        },
        countries: {
            type: Array,
            default: () => ({})
        },
        idNumbers: {
            type: Array,
            default: () => []
        },
        reloadClientData:{
            type: Boolean,
            default: true
        },
        lang: {
            type: String,
            default: "pl"
        },
        errors: {
            default: () => ({})
        },
        old: {
            default: () => ({})
        },
        values: {
            default: () => ({})
        },
        preview: {
            default: false
        },
        events: {
            default: true
        },
        sectionTitle: {
            type: String,
            default: 'department_and_client'
        },
        providerTitle: {
            type: String,
            default: 'attendant_department_data'
        },
        mode: {
            type: String,
            default: 'create'
        },
        permission_access : {
        	default: false
        }
    },
    computed: {
        isEnabledCopyButton() {
            return this.clientsForms == 0;
        }
    },
    methods: {
        clientCountryChange(value) {
            this.defaultCountry = value;
            this.$refs.attendant_department_form.setIdNumber(value)

        },
        departmentChange() {
            if(this.events && this.reloadClientData){
                this.$refs.client_form.updateFormCountry();
            }
            this.$refs.attendant_department_form.setIdNumber(this.getCountryToSetNumber())
        },
        clientIdTypeChange(value) {
            this.defaultIdNumberType = value * 1;
        },
        addClientForm() {
            this.clientsForms.push({
                id: this.rowsCount++,
                element: ClientDataForm
            });
        },
        addClientForms(quantity) {
            for (let index = 0; index < quantity; index++) {
                this.addClientForm();
            }
        },
        deleteClientForm(index) {
            let indexToDelete = this.clientsForms.findIndex(x => x.id == index);

            this.$delete(this.clientsForms, indexToDelete);
        },
        copyClientData() {
            this.isDataCopied = !this.isDataCopied;
            this.clientFormFirst = {...this.clientForm};
        },
        setData(data) {
            if (Object.keys(data).length != 0) {
                for (const [key, value] of Object.entries(data)) {
                    if (value != null) {
                        this.$set(this.clientForm, key, value[0]);
                    }
                }
                if (data.idNumberVies) {
                    this.$set(this.clientForm, 'idVies', data.idNumberVies);
                } else if (data.idNumberSecondaryVies) {
                    this.$set(this.clientForm, 'idSecondaryVies', data.idNumberSecondaryVies);
                }
            }
        },
        getCountryToSetNumber() {
            return this.$refs.client_form.$data.formData.departmentCountryChecked ? this.$refs.client_form.$data.formData.departmentCountrySelected : this.$refs.client_form.$data.formData.countrySelected;
        },
        getSortedIdNumbersTypes() {
            let array = [...this.idNumbers];
            let arraySorted = array.sort((a, b) => (a.text > b.text ? 1 : -1));

            let otherIndex = arraySorted.findIndex(element => {
                return element.text == "other";
            });
            arraySorted.push(arraySorted.splice(otherIndex, 1)[0]);

            let noneIndex = arraySorted.findIndex(element => {
                return element.text == "none";
            });
            arraySorted.push(arraySorted.splice(noneIndex, 1)[0]);

            return arraySorted;
        },
        ...mapActions(["saveCountriesTranslations"])
    },
    mounted() {
        this.$refs.attendant_department_form.setIdNumber(this.getCountryToSetNumber());
        this.$store.commit("setOld", {});
        this.$store.commit("setValues", {});
    },
    created() {
        this.saveCountriesTranslations(this.countryTranslations);
        this.$store.commit("setLang", this.lang);
        this.$store.commit("pushToCountriesSelect", this.countries);
        this.$store.commit(
            "setIdNumbersTypesSelect",
            this.getSortedIdNumbersTypes()
        );
        this.$store.commit("setCurrentSaDepartment", this.currentSaDepartment);
        this.$store.commit("setErrors", this.errors);
        this.$store.commit("setOld", this.old);
        this.$store.commit("setValues", this.values);


        if (Object.keys(this.old).length != 0) {
            this.addClientForms(Object.keys(this.old.name).length - 2);
            this.setData(this.old);
        } else if (Object.keys(this.values).length != 0) {
            this.addClientForms(Object.keys(this.values.name).length - 2);
            this.setData(this.values);
        }

        if (
            this.old.copyClientData != undefined ||
            (Object.keys(this.old).length == 0 &&
                this.values.isDataCopied != undefined &&
                this.values.isDataCopied)
        ) {
            this.isDataCopied = true;
        }
    }
};
</script>
